var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-carousel',{staticClass:"sliders",attrs:{"interval":3000,"height":_vm.clientHeight,"margin-top":"-30px","autoplay":true},on:{"change":_vm.changeHandle}},_vm._l((_vm.banners),function(banner){return _c('el-carousel-item',{key:banner.name,style:(banner.style)})}),1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fb6fa07c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Slider.vue
// module id = null
// module chunks = 